

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./User.Validator.js";

class UserAPI {


/*
undefinedPOST http://localhost:3000/users/register
Content-Type: application/json

{
    "email" : "trinhvietnambk@gmail.com",
    "password":"123123",
    "firstName":"Nam",
    "lastName":"Trịnh Viết",
    "type":["Contractor"]
}


*/    


  register = async (data) => {
    const validator = Validator.VALIDATION_REGISTERS_ACCOUNT;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/users/register", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*




POST http://localhost:3000/users/login
Content-Type: application/json

{
    "email" : "trinhvietnambk@gmail.com",
    "password":"123123",
    "type":"normal"
}


*/    


  loginNormal = async (data) => {
    // haizzzzz
    const servers = {
      development: {
        main: 'https://s1.dev.houselink.info',
        second: 'https://s2.dev.houselink.info',
        web: 'https://web.houselink.com.vn'
      },
      production_dev: {
        main: 'https://s3.dev.houselink.info',
        second: 'https://s4.dev.houselink.info',
        web: 'https://web.dev.houselink.info'
      },
      production_empty: {
        main: 'https://s5.dev.houselink.info',
        second: 'https://s6.dev.houselink.info',
        web: 'https://demo.dev.houselink.info'
      },
      localhost: {
        main: 'https://localhost:3000',
        second: 'http://localhost:4444',
        web: 'https://localhost:3333'
      }
    };

    const api_mode = window.localStorage.getItem('admin_api_mode') || 'production_empty';
    const server = servers[api_mode];
    const HOST2 = server.main;

    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST2 + "/users/login", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/users/login
Content-Type: application/json

{
    "accessToken":"EAACEdEose0cBAKmoYqRLNyQmroCw6ixCWZCQxVbRQEE6KnVmLxbVymyswiHKQdZBwcqLWZB4aFdyevoP5ElGzL9ZA2sk1Vt6v65tbScxlAolYLWF3ZCadb6Bw3CqtorE1e9LsGdoT3mVAQZCEJXh4bfJr9Gt9M5oBgRCKZAE1EaoZC5OqHqWnv30H2MZAt63y3BYZD",
    "type":"facebook"
}


*/    


  login = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/login", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*



POST http://localhost:3000/users/update
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNjUxMDgzMjcxMzkifQ.afBEkYoJPy0OlLsdpaPu3-_P-4RSTBaTDYHN_YOUT60

{
  "phone":"0165 605 3482"
}


*/    


  update = async (data) => {
    const validator = Validator.VALIDATION_ACCOUNTS_UPDATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        console.log(result.error);
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/users/update", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*




POST http://localhost:3000/users/changePassword
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI4MjYwNzk0NDg3NjUifQ.btQcpTPJfdOFGbsaxgKGWR31yIVKoWMtfqiaKt6As-E

{
  "password":"123123",
  "newPassword":"abcd123"
}


*/    


  changePassword = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/changePassword", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


GET http://api.houselink.com:3000/users/me
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{

}

*/    


  me = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.get(HOST + "/users/me", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  detail = async (userId) => {
    const validator = false; // change this to real vuserId
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.get(HOST + "/users/detail/" + userId, {});
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/users/logout
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI3Njc1MTQ2MTkyMTMifQ.S4E5fMlOqtw9qoz-4M8IfiKCMJrXRIPHVqEMgU3F95c

{

}

*/    


  logout = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/logout", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*



POST http://localhost:3000/users/projects
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "page":1
}

*/    


  projects = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/projects", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*





POST http://localhost:3000/users/myFavoriteFollowing
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "page":1
}

*/    


  myFavoriteFollowing = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if (result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/myFavoriteFollowing", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*



*/

  adminList = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    POST http://localhost:3000/users/blockUser
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI2NTc4MTYyMDM1MiIsImNyZWF0ZWRBdCI6MTUyMzU1MzEwNTA2Nn0.QaZkeJQ_Mi36UnNRkcze0SVzH_Ub8qChYSFy06qITwk

    {
      "id":"userId"
    }
    ###
  * */

  blockUser = async (data) => {
    const validator = Validator.VALIDATION_BLOCK_USER;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/users/blockUser", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    POST http://localhost:3000/users/unblockUser
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI2NTc4MTYyMDM1MiIsImNyZWF0ZWRBdCI6MTUyMzU1MzEwNTA2Nn0.QaZkeJQ_Mi36UnNRkcze0SVzH_Ub8qChYSFy06qITwk

    {
        "id":"userId"
    }
    ###
  * */

  unBlockUser = async (data) => {
    const validator = Validator.VALIDATION_UN_BLOCK_USER;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/users/unblockUser", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  /*
    POST http://api.houselink.com:3000/users/search
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI1NjUxMTkzODkxNzEiLCJjcmVhdGVkQXQiOjE1NDIxMTk5NDEyOTR9.kqcQwlVrHuyEcDyxqWoCvISUO5qwCoxJEj_xXqrDmGg

    {
       "email":"trinhviet@gmail.com"
    }
    ###
  * */
  search = async (data) => {
    const validator = Validator.VALIDATION_SEARCH_USER;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/users/search", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };
}
export default new UserAPI();



// WEBPACK FOOTER //
// ./src/services/user/User.API.js